export const ENGINE_TYPE = {
  DIESEL_TRUCK: 'Diesel Truck',
  HYBRID: 'Hybrid',
  PLUG_IN_HYBRID: 'Plug-In Hybrid',
  ELECTRIC: 'Electric Vehicle',
  EV_PLUG_IN_HYBRID: 'EV or<br/>Plug-In Hybrid',
};

export const ENGINE_TYPE_PARAMS = {
  [ENGINE_TYPE.DIESEL_TRUCK]: 'diesel',
  [ENGINE_TYPE.HYBRID]: 'hybrid',
  [ENGINE_TYPE.PLUG_IN_HYBRID]: 'plug-in hybrid',
  [ENGINE_TYPE.ELECTRIC]: 'electric',
  [ENGINE_TYPE.EV_PLUG_IN_HYBRID]: 'electric,plug-in hybrid',
};

export const BODY_TYPE_PARAMS = {
  [ENGINE_TYPE.DIESEL_TRUCK]: 'Pickup',
};

export const ENGINE_TYPE_RECOMMENDATION = {
  [ENGINE_TYPE.DIESEL_TRUCK]: {
    badges: [['icon-droplet1']],
    paragraphs: [
      "If you need to tow or haul while covering a lot of ground, there's still no substitute for a diesel truck.",
      'Electric trucks can do the job, but stopping to recharge while towing is both inconvenient and time-consuming.',
      'Diesel cars use diesel fuel, which contains more energy per gallon than gas, but not every filling station offers diesel fuel.',
    ],
  },
  [ENGINE_TYPE.HYBRID]: {
    badges: [['icon-power2', 'icon-droplet-contrast1']],
    paragraphs: [
      "If you can't charge at home, and you drive a lot, we recommend a hybrid.",
      'EVs and Plug-In Hybrids are convenient if you can charge (240V) at home, because charging at a station could take 10x longer than gas fill-ups.',
      "You don't need to charge a Hybrid because the battery is charged by both the gas engine and energy captured during braking.",
    ],
  },
  [ENGINE_TYPE.PLUG_IN_HYBRID]: {
    badges: [['icon-power-cord-thin', 'icon-droplet-contrast1']],
    paragraphs: [
      'You can fully charge the smaller battery in Plug-In Hybrids with a normal 110V electrical outlet.',
      'EVs can take multiple days to charge with a normal outlet, and require a more powerful 240V outlet.',
      'Plug-in Hybrids have a short all-electric range for daily driving, but also have gas engines that kick in when the battery runs down on longer trips.',
    ],
  },
  [ENGINE_TYPE.ELECTRIC]: {
    badges: [['icon-power2']],
    paragraphs: [
      'An EV is a great option if you have a reliable way to charge it at home or work.',
      'EVs have zero emissions, are cheaper to maintain, and provide instant acceleration, but are still more expensive than gas cars.',
    ],
  },
  [ENGINE_TYPE.EV_PLUG_IN_HYBRID]: {
    badges: [['icon-power2'], ['icon-power-cord-thin', 'icon-droplet-contrast1']],
    paragraphs: [
      'Taking road trips in an EV will require planning for long recharging stops every couple hundred miles.',
      'Plug-in Hybrids have a short all-electric range for daily driving, but also have gas engines that kick in when the battery runs down on longer trips.',
    ],
  },
};

export const SLIDES = [
  {
    question: 'Do you need to tow or haul heavy items often?',
    answers: [{ value: 'Yes', recommend: ENGINE_TYPE.DIESEL_TRUCK }, { value: 'No', nextSlideIndex: 1 }],
    subactionName: 'answer_quiz_tow',
  },
  {
    question: 'Do you have a way to charge an electric vehicle where it sits idle (i.e. home or work)?',
    answers: [
      { value: 'Yes, I have a regular electrical outlet (120V) I can use', recommend: ENGINE_TYPE.PLUG_IN_HYBRID },
      { value: 'Yes, I have a 240V electrical outlet (for large appliances) I can use', nextSlideIndex: 3 },
      {
        value: "No, I don't have an outlet where I park, but there's a public charging station nearby",
        nextSlideIndex: 2,
      },
      { value: "No, I don't have any way to charge an electric vehicle", recommend: ENGINE_TYPE.HYBRID },
    ],
    subactionName: 'answer_quiz_charge',
  },
  {
    question: 'How many miles do you typically drive per day (Americans on average drive 33 miles per day)?',
    answers: [
      { value: 'Not much - under 20 miles', recommend: ENGINE_TYPE.ELECTRIC },
      { value: 'I often drive over 20 miles per day', recommend: ENGINE_TYPE.HYBRID },
    ],
    subactionName: 'answer_quiz_drive',
  },
  {
    question: 'Will you be using this car for long road trips often?',
    answers: [
      { value: 'Yes, I frequently take long road trips', recommend: ENGINE_TYPE.EV_PLUG_IN_HYBRID },
      {
        value: 'No, I rarely take long road trips, or I have another vehicle for long road trips',
        recommend: ENGINE_TYPE.ELECTRIC,
      },
    ],
    subactionName: 'answer_quiz_trips',
  },
];
